import { render, staticRenderFns } from "./ClientsEditDoc.vue?vue&type=template&id=0ea6ac42"
import script from "./ClientsEditDoc.vue?vue&type=script&lang=js"
export * from "./ClientsEditDoc.vue?vue&type=script&lang=js"
import style0 from "./ClientsEditDoc.vue?vue&type=style&index=0&id=0ea6ac42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports